import { get, isString } from "lodash";
import { allTranslationJson } from "./index";

const defaultLocale = "en";
export const useTranslation = () => {
    let locale = "";
    locale = localStorage.getItem("locale") || defaultLocale;

    return {
        t: (term, key) => {
            const translation = get(
                allTranslationJson,
                `${locale}.["${isString(key) ? `${key}.` : ""}${term}"]`
            );
            return Boolean(translation) ? translation : term;
        },
        languages: locale,
        changeLanguage: (lang) => {
            localStorage.setItem("locale", lang);
            window.location.reload();
        },
        defaultLanguage: defaultLocale,
    };
};
